import React, { useEffect, useRef } from 'react'
import styles from './Project.module.scss'
import Button from './Button/Button'

import gsap, { Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Project = ({ title, description, projectImage, hoverImage, link }) => {

    AOS.init()
    AOS.refreshHard()
    gsap.registerPlugin(ScrollTrigger);

    const container = useRef(null)
    const image = useRef(null)
    
    // Create unique IDs for each project instance
    const uniqueId = Math.random().toString(36).substr(2, 9)
    const mainImgId = `mainImg_${uniqueId}`
    const hoverImgId = `himg_${uniqueId}`

    useEffect(() => {

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: container.current,
                toggleActions: "restart none none reset"
            }
        });

        tl.set(container.current, { autoAlpha: 1 });
        tl.from(container.current, 1.5, {
            xPercent: -100,
            ease: Power2.out
        });
        tl.from(image.current, 1.5, {
            xPercent: 100,
            scale: 1.3,
            delay: -1.5,
            ease: Power2.out
        });


        const items = document.getElementById(mainImgId)
        const image2 = document.getElementById(hoverImgId)

        let imageData
        items.addEventListener('mouseover', (e) => {
            imageData = e.target.getAttribute('data-image')
            image2.style.opacity = 1
            e.target.style.opacity = 0.4
            image2.setAttribute('src', imageData)
        })
        items.addEventListener('mousemove', (e) => {
            image2.style.top = e.clientY + 'px'
            image2.style.left = e.clientX + 'px'
        })
        items.addEventListener('mouseleave', (e) => {
            image2.style.opacity = 0
            e.target.style.zIndex = 1
            e.target.style.opacity = 1
            image2.setAttribute('src', '')
        })

    }, [hoverImgId, mainImgId])

    return (
        <div className={styles.project}>
            <div className={styles.container}>
                <div className={styles.textContainer}>
                    <div
                        data-aos="fade-left"
                        data-aos-delay="50"
                        data-aos-duration="2000"
                        data-aos-easing="ease-in-out"
                    >
                        <span className={styles.title}>{title}</span>
                    </div>
                    <p>{description}</p>
                    <div className={styles.button} >
                        <Button onClick={() => window.open(link, '_blank')} />
                    </div>
                    {/* <div className={styles.roundText}>
                        <RoundText color='#fff' />
                    </div> */}
                </div>

                <div ref={container} className={styles.projectImage} >
                    <img id={hoverImgId} src="" className={styles.hovImg} alt="Project hover preview" />
                    <img id={mainImgId} ref={image} src={projectImage} data-image={hoverImage} alt={`${title} project screenshot`} />
                </div>

            </div>

        </div>
    )
}

export default Project